import { PixelRatio } from 'react-native';

const dpr = parseInt(PixelRatio.get(), 10) || 1;

export default dpr;
